import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { SelectorTypesEnum } from "../../../types/enums";
import { getCaptionByType } from "../../../helpers/selectorFunctions";
import './style.css';
export var Slider = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, _b = _a.units, units = _b === void 0 ? SelectorTypesEnum.SUM : _b;
    var sliderRef = useRef(null);
    var _c = useState(false), isDragging = _c[0], setIsDragging = _c[1];
    // Функция для расчета нового значения на основе позиции указателя
    var calculateValue = useCallback(function (clientX) {
        if (!sliderRef.current)
            return;
        var rect = sliderRef.current.getBoundingClientRect();
        var clickX = clientX - rect.left;
        var sliderWidth = rect.width;
        var clickPercentage = clickX / sliderWidth;
        clickPercentage = Math.max(0, Math.min(1, clickPercentage)); // Ограничиваем от 0 до 1
        // Расчет индекса на основе процента
        var exactIndex = clickPercentage * (options.length - 1);
        var roundedIndex = Math.round(exactIndex);
        var clampedIndex = Math.max(0, Math.min(options.length - 1, roundedIndex));
        var newValue = options[clampedIndex];
        onChange(newValue);
    }, [onChange, options]);
    // Обработчик события pointer down
    var handlePointerDown = function (e) {
        e.preventDefault();
        setIsDragging(true);
        calculateValue(e.clientX);
        // Захват указателя для продолжения получения событий даже если указатель покинет элемент
        if (sliderRef.current) {
            sliderRef.current.setPointerCapture(e.pointerId);
        }
    };
    // Обработчик события pointer move
    var handlePointerMove = useCallback(function (e) {
        if (!isDragging)
            return;
        calculateValue(e.clientX);
    }, [isDragging, calculateValue]);
    // Обработчик события pointer up
    var handlePointerUp = useCallback(function (e) {
        if (isDragging) {
            setIsDragging(false);
            if (sliderRef.current) {
                sliderRef.current.releasePointerCapture(e.pointerId);
            }
        }
    }, [isDragging]);
    // Добавляем и удаляем обработчики событий при изменении состояния перетаскивания
    useEffect(function () {
        if (isDragging) {
            window.addEventListener('pointermove', handlePointerMove);
            window.addEventListener('pointerup', handlePointerUp);
        }
        else {
            window.removeEventListener('pointermove', handlePointerMove);
            window.removeEventListener('pointerup', handlePointerUp);
        }
        return function () {
            window.removeEventListener('pointermove', handlePointerMove);
            window.removeEventListener('pointerup', handlePointerUp);
        };
    }, [isDragging, handlePointerMove, handlePointerUp]);
    // Обработка клика по слайдеру
    var handleClick = function (e) {
        if (sliderRef.current) {
            calculateValue(e.clientX);
        }
    };
    var getIndexByType = function () {
        switch (units) {
            case SelectorTypesEnum.SUM: {
                if (typeof value === 'number') {
                    var numberOptions = options.filter(function (opt) { return typeof opt === 'number'; });
                    return numberOptions.indexOf(value);
                }
                return -1;
            }
            case SelectorTypesEnum.TERM: {
                if (typeof value === 'object') {
                    return options.findIndex(function (option) {
                        return typeof option === 'object' &&
                            option.value === value.value &&
                            option.vr === value.vr;
                    });
                }
                return -1;
            }
            default:
                return -1;
        }
    };
    // Вычисляем положение кружка
    var activeIndex = getIndexByType();
    var positionPercentage = activeIndex >= 0 ? (activeIndex / (options.length - 1)) * 100 : 0;
    return (_jsx("div", { className: "slider-container", children: _jsx("div", { className: "slider-block", children: _jsxs("div", { className: "slider", ref: sliderRef, onClick: handleClick, onPointerDown: handlePointerDown, style: { touchAction: "none" }, children: [_jsx("div", { className: "slider-track", style: {
                            background: "linear-gradient(to right, #005c32 ".concat(positionPercentage, "%, #c4c4c4 ").concat(positionPercentage, "%)"),
                        } }), _jsx("div", { className: "slider-thumb ".concat(isDragging ? "dragging" : ""), style: {
                            left: "".concat(positionPercentage, "%"),
                            transition: isDragging ? "none" : "left 0.3s",
                        } }), _jsx("div", { className: "min-max-row", children: options.length !== 0 && (_jsxs(_Fragment, { children: [_jsx("p", { children: getCaptionByType(options[0], units) }), _jsx("p", { children: getCaptionByType(options[options.length - 1], units) })] })) })] }) }) }));
};
